<!-- <section id="comp1" class="py-5 py-lg-6 bg-comp1 position-relative">
  <div class="container py-4">
    <div class="row align-items-center g-4">
      <div class="col-lg-6">
        <span class="display-5 fw-bold mb-3 fs-34px">Administra tu negocio con facilidad</span>
        <p class="lead text-muted fs-20px">Facturación, inventario y reportes en una sola plataforma. Rápido, simple y en la nube.</p>
        <div class="d-flex gap-2 mt-3">
          <button class="btn btn-sm d-flex align-items-center gap-2 py-2 px-3">Empieza gratis</button>
        </div>
        <div class="d-flex align-items-center gap-4 mt-4 text-muted small">
          <div class="d-flex align-items-center gap-1">
            <i class="fa-solid fa-check"></i><span>Sin tarjeta de crédito</span>
          </div>
          <div class="d-flex align-items-center gap-1">
            <i class="fa-solid fa-check"></i><span>Soporte en español</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow">
  <div class="container">
    <a class="navbar-brand fw-bold" href="#">CENTRIX <span class="text-success">POS</span></a>
    <div class="d-none d-md-block">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item"><a class="nav-link" href="#inicio">Inicio</a></li>
        <li class="nav-item"><a class="nav-link" href="#caracteristicas">Características</a></li>
        <li class="nav-item"><a class="nav-link" href="#precios">Precios</a></li>
        <li class="nav-item ms-lg-3">
          <button class="btn btn-success btn-sm rounded-pill px-3">Solicitar Demo</button>
        </li>
      </ul>
    </div>
  </div>
</nav> -->

<!-- <header id="inicio" class="hero-section text-white d-flex align-items-center">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 mb-5 mb-lg-0 text-center text-lg-start">
        <h1 class="display-3 fw-bold mb-3">Lleva tu negocio al siguiente nivel</h1>
        <p class="lead mb-4">Facturación Electrónica simple, rápida y 100% segura. Controla ventas, inventarios y SUNAT en un solo lugar.</p>
        <div class="d-grid d-md-flex justify-content-center justify-content-lg-start gap-3">
          <button class="btn btn-success btn-lg px-4 fw-bold shadow">Solicitar Demo Gratis</button>
          <button class="btn btn-outline-light btn-lg px-4">Ver Planes</button>
        </div>
      </div>
      <div class="col-lg-6 text-center">
        <img src="assets/imagenes/page_ventas_init.png" alt="Sistema POS" class="img-fluid rounded-3 shadow-lg floating-img">
      </div>
    </div>
  </div>
</header>

<section id="caracteristicas" class="py-5 bg-light">
  <div class="container py-5">
    <div class="text-center mb-5">
      <h2 class="fw-bold text-dark">Todo lo que necesitas para crecer</h2>
      <p class="text-muted">Software diseñado para la realidad de las PYMES en Perú.</p>
    </div>
    <div class="row g-4">
      <div class="col-md-4" *ngFor="let feature of features">
        <div class="card h-100 border-0 shadow-sm p-4 card-hover">
          <div class="feature-icon mb-3">
             <i [class]="feature.icon"></i>
          </div>
          <h4 class="fw-bold">{{feature.title}}</h4>
          <p class="text-muted">{{feature.desc}}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="precios" class="py-5">
  <div class="container py-5">
    <div class="text-center mb-5">
      <h2 class="fw-bold">Nuestros Planes</h2>
      <p class="text-muted">Precios transparentes, sin letras pequeñas.</p>
    </div>
    <div class="row g-4 justify-content-center">
      <div class="col-md-4" *ngFor="let plan of planes">
        <div class="card h-100 text-center border-0 shadow-sm p-4" [class.border-primary-plan]="plan.popular">
          <div *ngIf="plan.popular" class="popular-badge">Más Popular</div>
          <h3 class="fw-bold mt-3">{{plan.nombre}}</h3>
          <div class="price-box my-3">
            <span class="currency">S/</span>
            <span class="price display-5 fw-bold">{{plan.precio}}</span>
            <span class="period">/mes</span>
          </div>
          <ul class="list-unstyled mb-4 flex-grow-1">
            <li class="mb-2" *ngFor="let item of plan.items">
              <i class="bi bi-check-circle-fill text-success me-2"></i> {{item}}
            </li>
          </ul>
          <button class="btn w-100 py-3 fw-bold" [class.btn-primary]="plan.popular" [class.btn-outline-primary]="!plan.popular" (click)="contactarWhatsApp(plan.nombre)">
            Elegir Plan
          </button>
        </div>
      </div>
    </div>
  </div>
</section> -->

<!-- <section class="hero-carousel">
  <div class="carousel-item active" [ngClass]="sistemaActivo()">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-lg-6 text-content">
          <h1 *ngIf="sistemaActivo() === 'facturacion'">Sistema de Ventas y Facturación Electrónica</h1>
          <h1 *ngIf="sistemaActivo() === 'qr'">Web Encuéntrame con QR</h1>
          <h1 *ngIf="sistemaActivo() === 'ecommerce'">Ventas Online con Admin Interno</h1>
          
          <div class="actions mt-4">
            <a href="#planes" class="btn btn-primary me-3">Ver Planes</a>
            <button (click)="solicitarDemo()" class="btn btn-outline-light">Solicitar Demo</button>
          </div>
        </div>
        <div class="col-12 col-lg-6 img-container">
          </div>
      </div>
    </div>
  </div>
</section> -->

<!-- <section class="carousel-container">
  <div class="carousel-slide" *ngFor="let slide of slides; let i = index" [class.active]="i === currentIndex">
    <div class="container">
      <div class="row align-items-center min-vh-75">
        <div class="col-md-6 text-white content-fade">
          <h1 class="display-4 fw-bold">{{ slide.title }}</h1>
          <p class="lead">{{ slide.desc }}</p>
          <div class="mt-4">
            <button class="btn btn-primary btn-lg me-3">Ver Planes</button>
            <button class="btn btn-outline-light btn-lg">Solicitar Demo</button>
          </div>
        </div>
        <div class="col-md-6 d-none d-md-block">
          <img [src]="slide.img" class="img-fluid floating-img" [alt]="slide.title">
        </div>
      </div>
    </div>
  </div>
  
  <div class="carousel-dots">
    <span *ngFor="let dot of slides; let i = index" [class.active]="i === currentIndex" (click)='setSlide(i)'></span>
  </div>
</section> -->

<!-- <a href="https://wa.me/51900000000" class="whatsapp-float shadow" target="_blank">
  <i class="fa-brands fa-whatsapp fa-lg"></i>
</a> -->

<section id="inicio" class="hero d-flex align-items-center justify-content-center text-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <span class="badge rounded-pill mb-3 fs-24px">Soluciones tecnológicas para tu negocio</span>
        <h1 class="display-3 fw-bold text-white mb-4">Digitaliza y potencia <span class="text-teal">tu empresa</span></h1>
        <p class="lead text-white opacity-75 mb-5">
          Ofrecemos sistemas integrales de facturación electrónica, identificación QR y comercio online para llevar tu negocio al siguiente nivel.
        </p>
        <div class="d-flex justify-content-center gap-3">
          <button class="btn btnServicio btn-lg fs-18px" (click)="servicios()">Ver Servicios &rarr;</button>
          <button class="btn btnSabermas btn-lg fs-18px" (click)="saberMas()">Saber más</button>
        </div>
      </div>
    </div>
  </div>
</section>